/**************************************************
 * Nombre:       Seccion_Tratamiento_Datos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";
import Tratamiento_Portada from "./Componentes/Tratamiento_Portada";

const Seccion_Tratamiento_Datos = () => {


    useEffect(() => {
        irArriba()
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Tratamiento_Portada/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Tratamiento_Datos